import React from 'react';
import { useSelector } from 'react-redux';

import { getLoadingRedux } from 'reducers/shareData/selector';
import loadingLogo from './preload_logo.png';
import loadingImage from './sprites.png';
// const loadingLogo = require('./preload_logo.png');
// const loadingImage = require('./sprites.png');
// eslint-disable-next-line @typescript-eslint/no-var-requires
const Style = require('./Loading_style.module.css');

export const Loading = (): JSX.Element => {
  const loadingShow = useSelector(getLoadingRedux);

  const loadingBackgroundRef = React.createRef<HTMLDivElement>();
  const loadingImageRef = React.createRef<HTMLDivElement>();

  const cSpeed = 5;
  const cWidth = 50;
  const cHeight = 51;
  const cTotalFrames = 20;
  const cFrameWidth = 50;
  // const cImageSrc = '../../asset/inc/img/global/sprites.png';

  let cImageTimeout: number | undefined;
  let cIndex = 0;
  let cXpos = 0;
  let cPreloaderTimeout: number | undefined;
  let SECONDS_BETWEEN_FRAMES = 0;

  const stopAnimation = () => {
    // stops animation

    clearTimeout(cPreloaderTimeout);
    cPreloaderTimeout = undefined;
    if (loadingImageRef.current) {
      loadingImageRef.current.style.width = '0';
      loadingImageRef.current.style.height = '0';
    }
  };

  const continueAnimation: TimerHandler = () => {
    cXpos += cFrameWidth;
    // increase the index so we know which frame of our animation we are currently on
    cIndex += 1;

    // if our cIndex is higher than our total number of frames, we're at the end and should restart
    if (cIndex >= cTotalFrames) {
      cXpos = 0;
      cIndex = 0;
    }

    if (loadingImageRef.current) {
      loadingImageRef.current.style.backgroundPosition = `${-cXpos}px 0`;
    }

    if (loadingShow) {
      cPreloaderTimeout = setTimeout(
        // eslint-disable-next-line @typescript-eslint/no-implied-eval
        continueAnimation,
        SECONDS_BETWEEN_FRAMES * 1000
      );
    } else {
      stopAnimation();
    }
  };

  const startAnimation = () => {
    if (loadingImageRef.current) {
      loadingImageRef.current.style.backgroundImage = `url(${loadingImage})`;
      loadingImageRef.current.style.width = `${cWidth}px`;
      loadingImageRef.current.style.height = `${cHeight}px`;
    }
    const fps = Math.round(100 / cSpeed);
    SECONDS_BETWEEN_FRAMES = 1 / fps;

    cPreloaderTimeout = setTimeout(
      continueAnimation,
      SECONDS_BETWEEN_FRAMES / 1000
    );
  };

  // Pre-loads the sprites image
  const imageLoader = (s: string, fun: TimerHandler) => {
    clearTimeout(cImageTimeout);
    cImageTimeout = 0;
    const genImage = new Image();
    genImage.onload = () => {
      // eslint-disable-next-line @typescript-eslint/no-implied-eval
      cImageTimeout = setTimeout(fun, 0);
    };
    genImage.onerror = () => {
      if (process.env.REACT_APP_DEBUG_MODE === 'ON') {
        throw new Error('Could not load the image');
        //   return alert('Could not load the image');
      }
    };
    // genImage.onerror = new Function('alert(\'Could not load the image\')');
    genImage.src = s;
  };

  imageLoader(loadingImage, startAnimation);
  // new imageLoader(loadingImage, startAnimation);
  // if (!start) { stopAnimation(); }

  const fade = loadingShow ? Style.fadeIn : Style.fadeOut;

  return (
    <div
      id="loadingBackground"
      ref={loadingBackgroundRef}
      className={`${Style.loading_background} ${fade}`}
      // onClick={handleEndClick}
    >
      <div className={Style.loading}>
        {loadingShow && <img src={loadingLogo} alt="" />}
        <div
          id="loadingImage"
          ref={loadingImageRef}
          className={Style.loading_image}
        />
      </div>
    </div>
  );
};

export default Loading;
